import type { CanvasState } from '../hooks/useCanvasTransform';
import type { AABB } from '../utils/aabb';

export function renderOverlay(
  ctx: CanvasRenderingContext2D,
  state: CanvasState,
  bbox: AABB | null,
  rotation?: number
) {
  if (!bbox) return;
  const { x, y, width, height } = bbox;
  const lineWidth = 1 / state.scale;
  const handleSize = 8 / state.scale;

  const drawBoxAndHandles = () => {
    // bbox
    ctx.strokeStyle = '#0ea5e9';
    ctx.lineWidth = lineWidth;
    ctx.setLineDash([]);
    ctx.strokeRect(x, y, width, height);

    // handles (8)
    const hx = [x, x + width / 2, x + width];
    const hy = [y, y + height / 2, y + height];
    ctx.fillStyle = '#0ea5e9';
    for (let iy = 0; iy < 3; iy++) {
      for (let ix = 0; ix < 3; ix++) {
        if (ix === 1 && iy === 1) continue; // center skip
        const cx = hx[ix] - handleSize / 2;
        const cy = hy[iy] - handleSize / 2;
        ctx.fillRect(cx, cy, handleSize, handleSize);
      }
    }

    // rotate handle (top center, above bbox)
    const topCenterX = x + width / 2;
    const rotateOffset = 24 / state.scale; // distance above bbox
    const handleRadius = 6 / state.scale;

    // line from top center to rotate handle
    ctx.beginPath();
    ctx.moveTo(topCenterX, y);
    ctx.lineTo(topCenterX, y - rotateOffset);
    ctx.stroke();

    // circular rotate knob
    ctx.beginPath();
    ctx.arc(topCenterX, y - rotateOffset, handleRadius, 0, Math.PI * 2);
    ctx.fillStyle = '#0ea5e9';
    ctx.fill();
    ctx.lineWidth = lineWidth;
    ctx.strokeStyle = '#0ea5e9';
    ctx.stroke();
  };

  ctx.save();
  if (rotation && Math.abs(rotation) > 1e-6) {
    const cx = x + width / 2;
    const cy = y + height / 2;
    ctx.translate(cx, cy);
    ctx.rotate(rotation);
    ctx.translate(-cx, -cy);
    drawBoxAndHandles();
  } else {
    drawBoxAndHandles();
  }
  ctx.restore();
}



